(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairRoadshowSurveyController', PhysicalFairRoadshowSurveyController);

    PhysicalFairRoadshowSurveyController.$inject = ['PhysicalFairService', '$uibModal'];

    function PhysicalFairRoadshowSurveyController(PhysicalFairService, $uibModal) {
        var vm = this;
        vm.getSurveys       = getSurveys;
        vm.activate         = activate;
        vm.getByFilter      = getByFilter;
        vm.surveySelected   = '';
        vm.flag             = false;

        function activate() {
            vm.getSurveys();
        }

        function getSurveys() {
            PhysicalFairService.getSurveys().then(function(response) {
                vm.surveys = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag     = false;
            let query   = {};
            if(vm.surveySelected != '') {
                query['survey'] = vm.surveySelected;
            }
            PhysicalFairService.getSurveyQuestions(query).then(function(response) {
                console.log(response);
                vm.response         = response.data;
                vm.flag             = true;
            });
        }
        vm.activate();

    }
})();
